import { render } from "./SchoolBrowseView.vue?vue&type=template&id=3f3a79a2&scoped=true"
import script from "./SchoolBrowseView.vue?vue&type=script&lang=js"
export * from "./SchoolBrowseView.vue?vue&type=script&lang=js"

import "./SchoolBrowseView.vue?vue&type=style&index=0&id=3f3a79a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f3a79a2"]])

export default __exports__